module.exports = __webpack_public_path__ + "img/img-3.d00e6d63.png";